import React from "react";
import { Col, Row } from "react-bootstrap";

export default function Detail_Ozo_Inline({ item, isSub }) {
  let elementScore = item.normScore ? Math.round(Number(item.normScore)) : Math.round(item.score);

  const ScoreBlock = ({ number, isHit }) => {
    return (
      <div
        style={{
          height: 35,
          width: 40,
          border: "1px solid #0FE7F9",
          borderRadius: "7px",
          backgroundColor: isHit ? "#23C5D36B" : "#fbfbfb",
        }}
      >
        <Row className={"h-100 justify-content-center"}>
          <Col
            xs={"auto"}
            className={"align-content-center "}
            style={{
              textDecoration: "underline",
              fontSize: isHit ? "12px" : "10px",
              fontWeight: isHit ? "bold" : "normal",
            }}
          >
            {number}
          </Col>
        </Row>
      </div>
    );
  };

  const ScoreBar = ({ score }) => {
    return Array.from({ length: 10 }).map((_, index) => {
      const min = index * 10;
      const max = index * 10 + 9;
      return <ScoreBlock key={index} number={index + 1} isHit={score >= min && score <= max} />;
    });
  };

  return (
    <Row className={"mb-3 mx-0"}>
      <div className={"p-3"}>
        {/* Sub scope name if exists */}

        {/* Three column layout */}
        <Row className="align-items-center">
          {/* Left - Title */}
          <Col xs={3}>
            <Row>
              <Col xs={"auto"} className={"ps-0"}>
                <div
                  className={"rounded-circle flex-center "}
                  style={{
                    height: 50,
                    width: 50,
                    backgroundColor: "#0FE7F9",
                    fontWeight: 700,
                    fontSize: "20px",
                    color: "#404040",
                  }}
                >
                  {elementScore}
                </div>
              </Col>
              <Col xs={"auto"} className={"ps-0 align-content-center"}>
                <div style={{ fontSize: "20px", fontWeight: "600", color: "#092441" }}>{item.name}</div>
              </Col>
            </Row>
          </Col>

          {/* Center - Circular progress */}
          <Col xs={"auto"} className="d-flex ps-0">
            <ScoreBar score={elementScore}></ScoreBar>
          </Col>

          <Col>
            <div
              className="_scale-detail-text-pdf-new"
              style={{
                fontSize: "15px",
                color: "#666",
                lineHeight: "1.1",
                textAlign: "justify",
                textAlignLast: "right",
              }}
              dangerouslySetInnerHTML={{ __html: item.generalInformationText }}
            />
          </Col>
        </Row>
      </div>
    </Row>
  );
}
